export enum PriceConfigurationActions {
  RequestForConfiguration = 'request price configuration',
  PriceConfigurationAccepted = 'price configuration accepted',
  UpdateConfiguration = 'update price configuration',
  SetDefaultConfig = 'Clear price configuration',
  ToggleLoading = 'Toggle price configuration loader',
  CloseOnBoardModal = 'Close onboarding modal',
  CloseOnBoardCalendarModal = 'Close onboarding calendar modal',
  CloseOnBoardPriceModal = 'Close onboarding price configuration modal',
  ChangePriceSettingsTab = 'Change price settings tab',
  SetDiff = 'Set diff price settings',
  SetSettingsData = 'Set settings data price',
  SaveConfiguration = 'Save price configuration new',
  CloseModal = 'Close price configuration modal',
  SetErrorsSettings = 'Set errors settings',
  OpenFeeModal = 'Open fee modal',
  SetConfigurationLoading = 'Set configuration loading',
}

export enum PriceFormActions {
  CalculatePrices = 'request calculate new prices for price form',
  SubmitPriceForm = 'submit price form',
}

export enum PriceGridAction {
  RequestPrices = 'request prices for gird',
  RequestNewPrices = 'request new prices for gird',
  PricesAccepted = 'prices for grid accepted',
  PricesNewAccepted = 'prices New for grid accepted',
  OpenHint = 'open price hint',
  CloseHint = 'close price hint',
  ToggleBlockHint = 'toggle block price hint',
  ChangeDates = 'Change price grid dates',
  ManualChangeDate = 'ManuallyChangePriceGridDate',
  SetScroll = 'Set scroll price grid',
  ExpandRow = 'Expand row price grid',
  OpenRoomEditModal = 'Open room edit modal Grid',
  PutRoomSettings = 'Put room settings Grid',
  ChangeAirbnbFieldSettings = 'Change airbnb field settings Grid',
  ChangeBookingFieldSettings = 'Change booking field settings Grid',
  SaveRoomSettings = 'Save room settings Grid',
  ResetExpand = 'reset expanded rows in Grid',
  SetRoomSettingsAirbnbErrors = 'Set room settings airbnb errors Grid',
  SetRoomSettingsBookingErrors = 'Set room settings booking errors Grid',
  SetScrollThrottle = 'Set scroll throttle price grid',
  OpenRoomEditModalOnly = 'Open room edit modal Grid only',
  LoadRoomSettings = 'Load room settings Grid',
  LoadGlobalRoomSettings = 'Load global room settings Grid',
  PutRoomSettingsGlobal = 'Put room settings Global Grid',
  TogglePricesMulti = 'Toggle prices multi Grid',
  SetDisplayed = 'Set price configuration displayed',
  SetProvisionPopoutState = 'Set provision popout state',
  ExpandRooms = 'Expand rooms Grid',
  SetNewPricesLoading = 'Set new prices loading',
  SetPriceGridFilter = 'Set price grid filter',
  CopyPricesConfirm = 'Copy prices confirm',
  CopyPricesSuccess = 'Copy prices success',
  CopyPricesFailure = 'Copy prices failure',
  CopyPricesReset = 'Copy prices reset',
  RefreshBookingIntegrationsForPriceGrid = 'Refresh booking integrations for price grid',
}
